module.exports = __webpack_public_path__ + "static/media/clock(white).7a9824c9.svg";